// Generated types for SysMLStructure
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLClassifierReadAPI, SysMLClassifierWriteAPI } from './sysmlclassifier';
import { SysMLClassifierReadAPISchemaObject, SysMLClassifierWriteAPISchemaObject } from './sysmlclassifier';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLStructureReadAPI extends SysMLClassifierReadAPI {
}

export interface SysMLStructureWriteAPI extends SysMLClassifierWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLStructureReadAPISchemaObject = SysMLClassifierReadAPISchemaObject.extend({}).passthrough();
export const SysMLStructureReadAPISchema: z.ZodType<SysMLStructureReadAPI> = SysMLStructureReadAPISchemaObject;

export const SysMLStructureWriteAPISchemaObject = SysMLClassifierWriteAPISchemaObject.extend({}).passthrough();
export const SysMLStructureWriteAPISchema: z.ZodType<SysMLStructureWriteAPI> = SysMLStructureWriteAPISchemaObject;
